<template>
  <div class="">
    <policy-replace />
  </div>
</template>

<script>
import PolicyReplace from "@/components/wallet/policies/replace.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    PolicyReplace,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Sostituisci Polizza",
        path: "insurance_policies.replace",
        level: 3,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Sostituisci Polizza",
        path: "insurance_policies.replace",
        level: 3,
      });
    }
  },
};
</script>
